export default "__VITE_ASSET__CXcL8kCS__"